export const CONTACT_ROUTE = 'kontakt';
